<template>
  <v-audit
    ref="audit"
    :audit-params="auditParams"
    :show-form="showForm"
    only-yes
  ></v-audit>
</template>

<script>
export default {
  name: 'v-audit-only-yes',
  props: {
    auditParams: {
      type: Object,
      default: () => ({
        taskId: '',
        processInstanceId: '',
      }),
    },
    showForm: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    validate(...params) {
      return this.$refs.audit?.validate(...params) ?? true
    },
    submit() {
      return this.$refs.audit?.submit() ?? null
    },
  },
}
</script>
